import { render } from "./FooterCopyrightNonHome.vue?vue&type=template&id=7e2c86dc"
import script from "./FooterCopyrightNonHome.vue?vue&type=script&lang=js"
export * from "./FooterCopyrightNonHome.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__